import React from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _keyBy from 'lodash/keyBy';
import makeStyles from '@material-ui/core/styles/makeStyles';
import * as AttributeEditTypes from 'pages/AttributesEdit/typings';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

interface Props {
  values: AttributeEditTypes.AttributesEditFormValues;
  onChange: (field: string, value: any) => void;
}

function AttributeVisibility({ values, onChange }: Props) {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value === 'true';
    onChange('client.restricted', value);
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        className={classes.header}
        title="Visibility"
        subheader={
          <>
            Set the visibility of this attribute across Sift.{' '}
            <Link
              href="http://help.justsift.com/en/articles/12526057-sift-permission-types"
              target="_blank"
              rel="noopener noreferrer"
              color="secondary"
            >
              Learn more{' '}
            </Link>
            about permissions.
          </>
        }
      />
      <CardContent>
        <RadioGroup value={values.client.restricted ? 'true' : 'false'} onChange={handleChange}>
          <FormControlLabel
            value="false"
            className={classes.formLabel}
            control={<Radio className={classes.radio} />}
            label={
              <Typography variant="body2">
                <strong>Public</strong> - This attribute will be visible on all profiles in which
                the user has access to view.
              </Typography>
            }
          />
          <FormControlLabel
            value="true"
            className={classes.formLabel}
            control={<Radio className={classes.radio} />}
            label={
              <Typography variant="body2">
                <strong>Restricted</strong> - This attribute will only be visible on people for whom
                the user has the “View Restricted Attributes” permission.
              </Typography>
            }
          />
        </RadioGroup>
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  header: {
    paddingBottom: 0,
  },
  formLabel: {
    maxHeight: 40,
    marginBottom: theme.spacing(1.25),
    display: 'flex',
    alignItems: 'flex-start',
  },
  radio: {
    paddingTop: 0,
  },
}));

export default AttributeVisibility;
